<script setup>
import { ref } from "vue";
import dayjs from "dayjs";
import "dayjs/locale/id";
dayjs.locale("id");
const props = defineProps({
  agenda: {
    type: Array,
    required: true,
  },
});
const formatTanggal = (tanggal) => {
  return tanggal ? dayjs(tanggal).format("D MMMM YYYY") : null;
};
</script>
<style scoped>
.ribbon {
  background: linear-gradient(135deg,
      #1e3a8a 0%,
      /* indigo-800 */
      #2563eb 35%,
      /* blue-600 */
      #3b82f6 70%,
      /* blue-500 */
      #93c5fd 100%
      /* blue-300 */
    );
  color: #fff;
  font-weight: bold;
  font-size: 1.5rem;
  padding: 0.75rem 2rem;
  border-radius: 0 0 1.5rem 1.5rem;
  margin: 0 auto 2rem auto;
  width: fit-content;
  box-shadow: 0 8px 25px rgba(37, 99, 235, 0.28),
    0 4px 12px rgba(59, 130, 246, 0.2);
  letter-spacing: 1px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.ribbon::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent);
  transition: left 0.5s ease;
}

.ribbon:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 35px rgba(37, 99, 235, 0.38),
    0 6px 18px rgba(59, 130, 246, 0.28);
}

.ribbon:hover::before {
  left: 100%;
}

.icon {
  display: inline-block;
  vertical-align: middle;
  margin-right: 0.5rem;
  width: 1.2em;
  height: 1.2em;
  color: #2563eb;
}
</style>

<template>
  <div>
    <section class="z-0 pb-15">
      <h2 class="mb-10 text-center ribbon" v-if="agenda.data && agenda.data.length">Agenda Kegiatan</h2>
      <!-- Hero Content Start -->
      <div class="mx-auto max-w-[1170px] px-4 sm:px-8 xl:px-0 relative z-1">
        <div class="flex flex-wrap gap-x-7.5 gap-y-9">
          <!-- Iterasi agenda -->
          <div v-for="(item, idx) in agenda.data" :key="idx"
            class="max-w-[1170px] w-full flex flex-col lg:flex-row lg:items-center gap-7.5 lg:gap-11 bg-white shadow-1 rounded-xl p-4 lg:p-2.5 mb-6">
            <div class="lg:max-w-[536px] w-full">
              <a :href="item.link || '#'">
                <img class="w-full" :src="item.gambar ||
                  'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80'
                  " :alt="item.judul || 'Agenda'" />
              </a>
            </div>

            <div class="lg:max-w-[540px] w-full">
              <h1 class="mb-4 font-bold text-custom-4 xl:text-heading-4 text-dark">
                <a :href="item.link || '#'">
                  {{ item.judul || "Judul Agenda" }}
                </a>
              </h1>
              <p class="max-w-[524px]">
                {{ item.deskripsi || "Deskripsi agenda belum tersedia." }}
              </p>
              <p class="max-w-[524px] flex items-center">
                <!-- Calendar Icon SVG -->
                <span class="icon" aria-hidden="true">
                  <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                    <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" />
                    <path d="M16 2v4M8 2v4M3 10h18" stroke="currentColor" />
                  </svg>
                </span>
                {{
                  formatTanggal(item.tanggal_mulai) ||
                  "Tanggal mulai belum tersedia."
                }}
              </p>

              <p class="max-w-[524px] flex items-center">
                <!-- Location Icon SVG -->
                <span class="icon" aria-hidden="true">
                  <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                    <path d="M12 21s-6-5.686-6-10a6 6 0 1 1 12 0c0 4.314-6 10-6 10z" stroke="currentColor" />
                    <circle cx="12" cy="11" r="2.5" stroke="currentColor" />
                  </svg>
                </span>
                {{ item.lokasi || "Lokasi" }}
              </p>
              <p class="max-w-[524px] flex items-center text-blue-500 dark:text-blue-400">
                <!-- Status Icon SVG -->
                <span class="icon" aria-hidden="true">
                  <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" />
                    <path d="M9 12l2 2 4-4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </span>
                {{ item.status || "Status" }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- Hero Content End -->
    </section>
  </div>
</template>
